/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPublicFormsIdStatsParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  PostPublicFormsImagesBody,
  TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest,
  TrainWithMeModulesPublicFormsDtosRequestsSetPublicFormLinkRequest,
  TrainWithMeModulesPublicFormsDtosResponsesPublicFormDraftResponse,
  TrainWithMeModulesPublicFormsDtosResponsesPublicFormImageResponse,
  TrainWithMeModulesPublicFormsDtosResponsesPublicFormResponse,
  TrainWithMeModulesPublicFormsDtosResponsesPublicFormStatsResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getPublicForms = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPublicFormsDtosResponsesPublicFormResponse[]>(
      {url: `/public-forms`, method: 'GET', signal
    },
      options);
    }




export const getGetPublicFormsQueryKey = () => {
    return [
    `/public-forms`
    ] as const;
    }


export const getGetPublicFormsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicForms>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicForms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicFormsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicForms>>> = ({ signal }) => getPublicForms(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicForms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicFormsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicForms>>>
export type GetPublicFormsQueryError = ErrorType<unknown>


export function useGetPublicForms<TData = Awaited<ReturnType<typeof getPublicForms>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicForms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicForms>>,
          TError,
          Awaited<ReturnType<typeof getPublicForms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicForms<TData = Awaited<ReturnType<typeof getPublicForms>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicForms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicForms>>,
          TError,
          Awaited<ReturnType<typeof getPublicForms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicForms<TData = Awaited<ReturnType<typeof getPublicForms>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicForms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicForms<TData = Awaited<ReturnType<typeof getPublicForms>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicForms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicFormsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postPublicForms = (
    trainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPublicFormsDtosResponsesPublicFormResponse>(
      {url: `/public-forms`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest, signal
    },
      options);
    }




export const getPostPublicFormsMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicForms>>, TError,{data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPublicForms>>, TError,{data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest>}, TContext> => {

const mutationKey = ['postPublicForms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPublicForms>>, {data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postPublicForms(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPublicFormsMutationResult = NonNullable<Awaited<ReturnType<typeof postPublicForms>>>
    export type PostPublicFormsMutationBody = BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest> | undefined
    export type PostPublicFormsMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostPublicForms = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicForms>>, TError,{data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPublicForms>>,
        TError,
        {data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest>},
        TContext
      > => {
      return useMutation(getPostPublicFormsMutationOptions(options), queryClient);
    }
    export const getPublicFormsDefaults = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPublicFormsDtosResponsesPublicFormDraftResponse>(
      {url: `/public-forms/defaults`, method: 'GET', signal
    },
      options);
    }




export const getGetPublicFormsDefaultsQueryKey = () => {
    return [
    `/public-forms/defaults`
    ] as const;
    }


export const getGetPublicFormsDefaultsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicFormsDefaults>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsDefaults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicFormsDefaultsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicFormsDefaults>>> = ({ signal }) => getPublicFormsDefaults(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsDefaults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicFormsDefaultsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicFormsDefaults>>>
export type GetPublicFormsDefaultsQueryError = ErrorType<unknown>


export function useGetPublicFormsDefaults<TData = Awaited<ReturnType<typeof getPublicFormsDefaults>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsDefaults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicFormsDefaults>>,
          TError,
          Awaited<ReturnType<typeof getPublicFormsDefaults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicFormsDefaults<TData = Awaited<ReturnType<typeof getPublicFormsDefaults>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsDefaults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicFormsDefaults>>,
          TError,
          Awaited<ReturnType<typeof getPublicFormsDefaults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicFormsDefaults<TData = Awaited<ReturnType<typeof getPublicFormsDefaults>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsDefaults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicFormsDefaults<TData = Awaited<ReturnType<typeof getPublicFormsDefaults>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsDefaults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicFormsDefaultsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postPublicFormsImages = (
    postPublicFormsImagesBody?: BodyType<PostPublicFormsImagesBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(postPublicFormsImagesBody?.file !== undefined) {
 formData.append(`file`, postPublicFormsImagesBody.file);
 }

      return customInstance<TrainWithMeModulesPublicFormsDtosResponsesPublicFormImageResponse>(
      {url: `/public-forms/images`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPostPublicFormsImagesMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicFormsImages>>, TError,{data?: BodyType<PostPublicFormsImagesBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPublicFormsImages>>, TError,{data?: BodyType<PostPublicFormsImagesBody>}, TContext> => {

const mutationKey = ['postPublicFormsImages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPublicFormsImages>>, {data?: BodyType<PostPublicFormsImagesBody>}> = (props) => {
          const {data} = props ?? {};

          return  postPublicFormsImages(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPublicFormsImagesMutationResult = NonNullable<Awaited<ReturnType<typeof postPublicFormsImages>>>
    export type PostPublicFormsImagesMutationBody = BodyType<PostPublicFormsImagesBody> | undefined
    export type PostPublicFormsImagesMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostPublicFormsImages = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicFormsImages>>, TError,{data?: BodyType<PostPublicFormsImagesBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPublicFormsImages>>,
        TError,
        {data?: BodyType<PostPublicFormsImagesBody>},
        TContext
      > => {
      return useMutation(getPostPublicFormsImagesMutationOptions(options), queryClient);
    }
    export const putPublicFormsId = (
    id: number,
    trainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPublicFormsDtosResponsesPublicFormResponse>(
      {url: `/public-forms/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest, signal
    },
      options);
    }




export const getPutPublicFormsIdMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPublicFormsId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPublicFormsId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest>}, TContext> => {

const mutationKey = ['putPublicFormsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPublicFormsId>>, {id: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  putPublicFormsId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPublicFormsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPublicFormsId>>>
    export type PutPublicFormsIdMutationBody = BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest> | undefined
    export type PutPublicFormsIdMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePutPublicFormsId = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPublicFormsId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPublicFormsId>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSavePublicFormRequest>},
        TContext
      > => {
      return useMutation(getPutPublicFormsIdMutationOptions(options), queryClient);
    }
    export const patchPublicFormsIdLink = (
    id: number,
    trainWithMeModulesPublicFormsDtosRequestsSetPublicFormLinkRequest?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSetPublicFormLinkRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPublicFormsDtosResponsesPublicFormResponse>(
      {url: `/public-forms/${id}/link`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesPublicFormsDtosRequestsSetPublicFormLinkRequest, signal
    },
      options);
    }




export const getPatchPublicFormsIdLinkMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPublicFormsIdLink>>, TError,{id: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSetPublicFormLinkRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPublicFormsIdLink>>, TError,{id: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSetPublicFormLinkRequest>}, TContext> => {

const mutationKey = ['patchPublicFormsIdLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPublicFormsIdLink>>, {id: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSetPublicFormLinkRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPublicFormsIdLink(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchPublicFormsIdLinkMutationResult = NonNullable<Awaited<ReturnType<typeof patchPublicFormsIdLink>>>
    export type PatchPublicFormsIdLinkMutationBody = BodyType<TrainWithMeModulesPublicFormsDtosRequestsSetPublicFormLinkRequest> | undefined
    export type PatchPublicFormsIdLinkMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePatchPublicFormsIdLink = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPublicFormsIdLink>>, TError,{id: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSetPublicFormLinkRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchPublicFormsIdLink>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsSetPublicFormLinkRequest>},
        TContext
      > => {
      return useMutation(getPatchPublicFormsIdLinkMutationOptions(options), queryClient);
    }
    export const postPublicFormsIdLinkRotate = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPublicFormsDtosResponsesPublicFormResponse>(
      {url: `/public-forms/${id}/link/rotate`, method: 'POST', signal
    },
      options);
    }




export const getPostPublicFormsIdLinkRotateMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicFormsIdLinkRotate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPublicFormsIdLinkRotate>>, TError,{id: number}, TContext> => {

const mutationKey = ['postPublicFormsIdLinkRotate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPublicFormsIdLinkRotate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postPublicFormsIdLinkRotate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPublicFormsIdLinkRotateMutationResult = NonNullable<Awaited<ReturnType<typeof postPublicFormsIdLinkRotate>>>

    export type PostPublicFormsIdLinkRotateMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostPublicFormsIdLinkRotate = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicFormsIdLinkRotate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPublicFormsIdLinkRotate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostPublicFormsIdLinkRotateMutationOptions(options), queryClient);
    }
    export const getPublicFormsIdStats = (
    id: number,
    params?: GetPublicFormsIdStatsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPublicFormsDtosResponsesPublicFormStatsResponse>(
      {url: `/public-forms/${id}/stats`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPublicFormsIdStatsQueryKey = (id: number,
    params?: GetPublicFormsIdStatsParams,) => {
    return [
    `/public-forms/${id}/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPublicFormsIdStatsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicFormsIdStats>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(id: number,
    params?: GetPublicFormsIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsIdStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicFormsIdStatsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicFormsIdStats>>> = ({ signal }) => getPublicFormsIdStats(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsIdStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicFormsIdStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicFormsIdStats>>>
export type GetPublicFormsIdStatsQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetPublicFormsIdStats<TData = Awaited<ReturnType<typeof getPublicFormsIdStats>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 id: number,
    params: undefined |  GetPublicFormsIdStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsIdStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicFormsIdStats>>,
          TError,
          Awaited<ReturnType<typeof getPublicFormsIdStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicFormsIdStats<TData = Awaited<ReturnType<typeof getPublicFormsIdStats>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 id: number,
    params?: GetPublicFormsIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsIdStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicFormsIdStats>>,
          TError,
          Awaited<ReturnType<typeof getPublicFormsIdStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicFormsIdStats<TData = Awaited<ReturnType<typeof getPublicFormsIdStats>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 id: number,
    params?: GetPublicFormsIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsIdStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicFormsIdStats<TData = Awaited<ReturnType<typeof getPublicFormsIdStats>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 id: number,
    params?: GetPublicFormsIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsIdStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicFormsIdStatsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






